<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Payments and Deductions</h1>
    <p>Qtac provide a standard library of payments to each client - <a href="#" @click.prevent="showHelpPanel = !showHelpPanel">view payments and deductions</a>.</p>
    <div class="help-panel" style="margin-bottom: 20px;" v-if="showHelpPanel" >
      <div style="float: right;"><button type="button" style="font-size: 40px; margin-top:-20px;" @click.prevent="showHelpPanel = !showHelpPanel">&times;</button></div>
      <h4>Default Payments</h4>
      <div style="display: flex; gap: 16px;">
        <ul v-if="defaultPayments.length" style="width: 50%; margin: 0; margin-left: 1.25rem; margin-top:8px;">
          <li v-for="(payment, idx) in defaultPayments.slice(0, 8)" :key="idx">
        {{ payment }}
          </li>
        </ul>
        <ul v-if="defaultPayments.length > 8" style="width: 50%; margin: 0;">
          <li v-for="(payment, idx) in defaultPayments.slice(8)" :key="'col2-' + idx">
        {{ payment }}
          </li>
        </ul>
      </div>
      </div>
    <div class="help-panel" style="margin-bottom: 20px;" v-if="showHelpPanel" >
      <h4>Default Deductions</h4>
      <p>
        <ul>
          <li v-for="(deduction, idx) in defaultDeductions" :key="idx">
            {{ deduction }}
          </li>
        </ul>
      </p>
    </div>
    <p>Would you like to discuss any requirements beyond Qtac's standard payments and deductions?</p>



    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.requiresOwnAdditionDeductions">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.requiresOwnAdditionDeductions">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'
import defaultPayments from '@/helpers/arrays/defaultPayments';
import defaultDeductions from '@/helpers/arrays/defaultDeductions';
const error = ref(null)

const showHelpPanel = ref(false);
const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.requiresOwnAdditionDeductions === undefined || props.formData.requiresOwnAdditionDeductions === null || props.formData.requiresOwnAdditionDeductions === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}



defineExpose({ validateStep, executeStep });

</script>